/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_AccentInputs */

const cs_settings_office_accent = /** @type {(inputs: Settings_Office_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barva kanceláře`)
};

const en_settings_office_accent = /** @type {(inputs: Settings_Office_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office colour`)
};

/**
* | output |
* | --- |
* | "Office colour" |
*
* @param {Settings_Office_AccentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_accent = /** @type {((inputs?: Settings_Office_AccentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_AccentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_accent(inputs)
	return cs_settings_office_accent(inputs)
});